
    <ng-container #entryPoint></ng-container>
    <router-outlet></router-outlet>
  


// WEBPACK FOOTER //
// ./src/compat/compat.component.ts.CompatComponent.html